import axiosInstance from '../auth/axiosInstance';

export const getCapabilities = async (projectId) => {
  try {
    const { data } = await axiosInstance.get(
      `/Capability/get-all-capabilities/${projectId}`
    );
    return data;
  } catch (error) {
    console.error('Error during capabilities fetch:', error.message);
    throw new Error(error.message);
  }
};

export const getProjectState = async (payload) => {
  try {
    const { data } = await axiosInstance.post('/Capability/get-project-state', payload);
    return data;
  } catch (error) {
    if (error.response?.status === 401) {
      console.error('Unauthorized access - token might be expired');
      throw new Error('Unauthorized - Please login again');
    }
    console.error('Error during get project state:', error.message);
    throw new Error(error.message);
  }
};

export const getRadarChart = async (payload) => {
  try {
    const { data } = await axiosInstance.post('/Assessment/get-capabilities-graph', payload);
    return data;
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;

    console.error('Error fetching radar chart:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const getAssessSubmitMemberCount = async (payload) => {
  try {
    const { data } = await axiosInstance.post(
      '/Capability/get-assess-submit-member-count/',
      payload
    );
    return data;
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;
    console.error('Error fetching assess submit member count:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const getwalkthroughsteps = async () => {
  try {
    const { data } = await axiosInstance.get('/Walkthrough/walkthroughsteps/');
    return data;
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;
    console.error('Failed to load walkthrough steps:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const getgetwalkthroughstepprogress = async (userId) => {
  try {
    const { data } = await axiosInstance.get(
      `/Walkthrough/getwalkthroughstepprogress/${userId}`
    );
    return data;
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;
    console.error('Failed to load walkthrough steps:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const Addwalkthroughstepprogress = async (payload) => {
  try {
    const { data } = await axiosInstance.post(
      '/Walkthrough/Addwalkthroughstepprogress/',
      payload
    );
    return data;
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message || error.message
      : error.message;
    console.error('Error fetching assess submit member count:', errorMessage);
    throw new Error(errorMessage);
  }
};

export { getgetwalkthroughstepprogress as getWalkthroughStepProgress };
